module.exports = __webpack_public_path__ + "media/images/default/shared/footer/bg-line-47050eba258b79c9964854e2eaea98d1.svg";